import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CheckCircle, XCircle, Clock } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";

export default function KehadiranDetail() {
  const { kind } = useParams();
  const [data, setData] = useState(null);
  const isGuru = kind === "guru";
  useEffect(() => { api.get(`/admin/attendance-detail?kind=${kind}`).then((r) => setData(r.data)); }, [kind]);

  return (
    <div>
      <PageHeader title={isGuru ? "Kehadiran Guru Hari Ini" : "Kehadiran Murid Hari Ini"} />
      <div className="px-5 pt-4 pb-10">
        {!data ? <p className="text-center text-stone-400 mt-8">Memuat...</p> : (
          <div className="space-y-5">
            {data.groups.length === 0 && <p className="text-center text-stone-400 mt-8">Belum ada data.</p>}
            {data.groups.map((g) => (
              <div key={g.kelas} data-testid={`kehadiran-kelas-${g.kelas}`}>
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-bold text-primary bg-primary/10 px-2.5 py-1 rounded-full">{g.kelas}</span>
                  <span className="text-[11px] text-green-600 font-semibold">{g.hadir.length} hadir</span>
                  <span className="text-[11px] text-red-500 font-semibold">{g.tidak.length} tidak</span>
                  <div className="flex-1 h-px bg-stone-200/70" />
                </div>
                <div className="space-y-1.5">
                  {g.hadir.map((p, i) => (
                    <div key={`h${i}`} className="bg-white rounded-xl border border-green-100 p-2.5 flex items-center justify-between shadow-sm">
                      <span className="flex items-center gap-2 text-sm font-semibold text-stone-800">
                        <CheckCircle size={18} weight="fill" className="text-green-500" /> {p.name}
                      </span>
                      {isGuru && <span className="text-xs text-stone-500 flex items-center gap-1"><Clock size={13} weight="fill" />{p.time_in ? `${p.time_in} WIB` : "-"}{p.status === "Terlambat" ? " • Terlambat" : ""}</span>}
                    </div>
                  ))}
                  {g.tidak.map((p, i) => (
                    <div key={`t${i}`} className="bg-white rounded-xl border border-red-100 p-2.5 flex items-center justify-between shadow-sm">
                      <span className="flex items-center gap-2 text-sm font-semibold text-stone-600">
                        <XCircle size={18} weight="fill" className="text-red-400" /> {p.name}
                      </span>
                      <span className="text-xs text-stone-400">{p.status}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
